import { doRefreshToken } from './auth.service';
import userStore from '../stores/user.store';

export class IdleCheckRefreshComponent {

    refreshTokenIntervalId = null;

    checkTime = () => {
        if (window.lastActivity <= Date.now() - 300000) {
            console.log('Refreshing the token');
            doRefreshToken().then(res => {
                userStore.userToken = res;
            });
        }
    };

    registerIdleChecker = () => {
        window.lastActivity = Date.now();
        document.addEventListener('click', () => {
            window.lastActivity = Date.now();
        });

        window.setInterval(this.checkTime, 180000);
    };

    registerRefreshToken = () => {
        if (this.refreshTokenIntervalId !== null) {
            return;
        }
        this.refreshTokenIntervalId = window.setInterval(this.refreshToken, 180000);
    };

    unregisterRefreshToken = () => {
        if (this.refreshTokenIntervalId === null) {
            return;
        }
        window.clearInterval(this.refreshTokenIntervalId);
        this.refreshTokenIntervalId = null;
    };

    refreshToken = () => {
        const refreshRequest = doRefreshToken();
        if (!refreshRequest) {
            this.unregisterRefreshToken();
            return;
        }
        refreshRequest.then(res => {
            if (res) {
                userStore.userToken = res;
            }
        }).catch(err => {
            console.error('FB', err);
        });
    };
}

const idleCheckRefreshComponent = new IdleCheckRefreshComponent();

export default idleCheckRefreshComponent;
